import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.clientes.empresas.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Empresa ha sido creada con éxito."}
                title={"Nueva Empresa"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                buttonTitle={"Nueva Empresa"}
                closeButton={true}
                buttonClass={this.props.buttonClass}
            >
                <Row>
                    <Col className="col-4 col-md-3">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Razón Social</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="razonSocial"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>CUIT</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="cuit"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Clasificación</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"clasificacion_id"} url={api.clientes.clasificacion.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Rubro</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"rubro_id"} url={api.clientes.rubros.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>País</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"pais_id"} url={api.misc.paises.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/Create.js